"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function () {
    return _Label.MARKING_TYPE;
  }
});
exports.STYLE_TYPE = void 0;
var _Label = require("b2b-components/theme/components/Form/Label");
let STYLE_TYPE = exports.STYLE_TYPE = /*#__PURE__*/function (STYLE_TYPE) {
  STYLE_TYPE["outlined"] = "outlined";
  STYLE_TYPE["underlined"] = "underlined";
  return STYLE_TYPE;
}({});
//# sourceMappingURL=Select.types.js.map